module.exports = __webpack_public_path__ + "img/big3-14.b8e478cd.jpg";